import { Switch, SwitchProps } from '@makyoapp/makyo-tw-ui'

export type CompSwitchProps = SwitchProps

/**
 * CompSwitchCore
 */
export const CompSwitchCore = (props: CompSwitchProps) => {
  return <Switch {...props} />
}
